import React, { useEffect } from 'react'

export type ToastVariant = 'success' | 'info' | 'error'

export type ToastState = {
  variant: ToastVariant
  message: string
} | null

const variantClass: Record<ToastVariant, string> = {
  success: 'alert alert-success',
  info: 'alert alert-info',
  error: 'alert alert-danger',
}

export const Toast = ({ toast, onDismiss }: { toast: ToastState; onDismiss: () => void }) => {
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(onDismiss, 5000)
      return () => clearTimeout(timer)
    }
  }, [toast, onDismiss])

  if (!toast) return null

  return (
    <div className={`${variantClass[toast.variant]} mb-md flex justify-between items-center`}>
      <span>{toast.message}</span>
      <button className="ml-md text-lg font-bold" onClick={onDismiss} aria-label="Dismiss">
        &times;
      </button>
    </div>
  )
}
